export default "/images/0191f62fc3470ea93a2428dd179163ed.avif";